<template>
  <div class="form-control" :class="{invalid: error, light: isLight}">
    <label :for="id">{{ label }}</label>
    <input
        :type="type"
        :id="id"
        :placeholder="placeholder"
        :value="modelValue"
        @input="change"
        v-maska
        :data-maska="dataMaska"
    >
    <small v-if="error">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: "VCustomInput",
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
    placeholder: String,
    label: String,
    error: String,
    type: String,
    isLight: Boolean,
    dataMaska: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      id: 'input-' + Math.random()
    }
  },
  methods: {
    change(event) {
      this.$emit('update:modelValue', event.target.value)
    }
  }
}
</script>

<style scoped>

</style>